import {Store} from "vuex";
import {Notice} from "@service/components/toast/type/Notice";
import i18n from "@service/locale/i18";
import {NoticeLevel} from "@service/components/toast/type/Enums";

export const showWarningThatSomeoneIsAlreadySharing = (store: Store<any>) => {
    store.dispatch('notice/submitNotice',  {
        text: i18n.t('web-conferences.media-library.errors.busy').toString(),
        level: NoticeLevel.warning
    } as Notice)
}
